import { useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getOrgBranding, updateOrgBranding } from "@/api/client";

export function useOrgBranding() {
  return useQuery({
    queryKey: ["orgBranding"],
    queryFn: getOrgBranding,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateOrgBranding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateOrgBranding,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orgBranding"] });
    },
  });
}

const BRANDING_CSS_MAP = {
  primaryColor: ["--primary", "--ring", "--sidebar-active", "--chart-1"],
  secondaryColor: ["--accent", "--chart-2"],
} as const;

export function useBrandingTheme() {
  const { data: branding } = useOrgBranding();

  useEffect(() => {
    const style = document.documentElement.style;
    const applied: string[] = [];

    for (const [field, vars] of Object.entries(BRANDING_CSS_MAP)) {
      const value = branding?.[field as keyof typeof BRANDING_CSS_MAP] as string | null;
      if (value) {
        for (const v of vars) {
          style.setProperty(v, value);
          applied.push(v);
        }
      }
    }

    return () => {
      for (const v of applied) {
        style.removeProperty(v);
      }
    };
  }, [branding?.primaryColor, branding?.secondaryColor]);
}
